if (!customElements.get('campaigns-element')) {
  customElements.define(
    'campaigns-element',
    class CampaignsElement extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.campaigns = {};
        this.activeCampaign = null;
        this.cartUpdated = false;
        this.cartUpdateFailure = false;
        this.prevCampaigns = this.querySelectorAll('.campaign-block');
        this.cart = document.querySelector('cart-notification') || document.querySelector('drawer-cart');
        this.inCart = window.location.pathname === '/cart';
        this.checkCart();
      }

      connectedCallback() {
        document.addEventListener('ajaxProduct:added', (event) => {
          this.onCartUpdate(event);
        });
        document.addEventListener('cart:update', (event) => {
          this.onCartUpdate(event);
        });
      }

      disconnectedCallback() {
        document.removeEventListener('ajaxProduct:added', (event) => {
          this.onCartUpdate(event);
        });
        document.removeEventListener('cart:update', (event) => {
          this.onCartUpdate(event);
        });
      }

      async onCartUpdate(event) {
        let sectionRoute = this.inCart ? routes.cart_url : '/';
        fetch(`${sectionRoute}?section_id=campaigns`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('campaigns-element');
            this.prevCampaigns = this.querySelectorAll('.campaign-block');
            this.innerHTML = sourceQty.innerHTML;
          })
          .then(() => {
            this.removeIneligibleGifts();
          })
          .then(() => {
            if (!this.cartUpdateFailure) {
              return this.checkCart();
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      async removeIneligibleGifts() {
        const campaignBlocks = this.querySelectorAll('.campaign-block');

        if (this.prevCampaigns.length > campaignBlocks.length) {
          const prevGiftsArr = Array.from(this.prevCampaigns);
          const prevGiftsIdsData = prevGiftsArr.map((item) => item.dataset.campaignGiftVariantIds);
          const prevGiftsIds =
            prevGiftsIdsData
              .map((item) => item.split(','))
              ?.flat()
              ?.filter((arr) => arr) || [];
          const giftsIdsData = Array.from(campaignBlocks).map((item) => item.dataset.campaignGiftVariantIds);
          const giftIds =
            giftsIdsData
              .map((item) => item.split(','))
              ?.flat()
              ?.filter((arr) => arr) || [];
          const giftIdsSet = new Set(giftIds.map((number) => number));
          const giftIdsToRemove = prevGiftsIds.filter((number) => !giftIdsSet.has(number));
          if (giftIdsToRemove.length == 0) return;
          const cartData = await this.updateCart(null, 0, giftIdsToRemove);
          const event = new CustomEvent('ajaxProduct:added', { detail: { cart: cartData, source: 'campaign' } });
          document.dispatchEvent(event);
          this.cartUpdateFailure = false;
        }
      }

      showWarningMessage() {
        const warningMessage = document.querySelector('.warning-message');
        if (warningMessage && !warningMessage.classList.contains('hidden')) {
          warningMessage.classList.add('hidden');
        }
      }

     hideWarningMessage() {
      const warningMessage = document.querySelector('.warning-message');
      if (warningMessage && warningMessage.classList.contains('hidden')) {
        warningMessage.classList.remove('hidden');
      }
     }

      async checkCart() {
        const campaignBlocks = this.querySelectorAll('.campaign-block');
        let cartData;
        this.campaigns = {};
        this.activeCampaign = null;
        let prizesToSelect = false;

        for (const campaignElem of campaignBlocks) {

          // Get cart data
          const cartJson = await fetch(window.Shopify.routes.root + 'cart.js')
            .then((response) => response.json());
          // If true, user will select prize manually from choices
          const prizeSelection = JSON.parse(campaignElem.dataset.prizeSelection);
          // Campaign name
          const campaignName = campaignElem.dataset.campaignName;
          // Variant id and key of the prize product
          const giftVariantId = campaignElem.dataset.campaignGiftVariantId;

          // How many gift products the user is eligible for
          const campaignEligibleAmount = parseInt(campaignElem.dataset.campaignEligibleAmount);
          // How many campaign prizes are in cart currently
          const prizesInCart = parseInt(campaignElem.dataset.campaignPrizesInCart);
          // How many prize products should be in cart
          let prizeQuantity = campaignEligibleAmount - prizesInCart;

          // Redirect customer to prize selection page if prize selection is manual
          if (prizeQuantity > 0 && prizeSelection) prizesToSelect = true;

          if (!prizeSelection && prizeQuantity > 0) {
            // If not manual selection, add prize to cart
            cartData = await this.addToCart(giftVariantId, prizeQuantity, campaignName);
            const event = new CustomEvent('ajaxProduct:added', { detail: cartData });
            document.dispatchEvent(event);
          } else if (prizeQuantity < 0) {
            // If prize quantity is negative, remove prize from cart
            prizeQuantity += prizesInCart;
            if (prizeSelection) {
              prizeQuantity = prizeQuantity - 1 < 0 ? 0 : prizeQuantity - 1;
            }
            cartData = await this.updateCart(giftVariantId, prizeQuantity);
            const event = new CustomEvent('ajaxProduct:added', { detail: cartData, });
            document.dispatchEvent(event);
          }
        }
        // const campaignSelectionButtons = document.querySelector('#campaign-selection-redirect');
        // const checkoutButton = document.querySelector('#checkout');
        // console.log('inCart', this.inCart);
        // console.log(window.location.pathname);
        // if (prizesToSelect && !this.inCart) {
        //   console.log('prizesToSelect');
        //   campaignSelectionButtons?.classList.remove('hidden');
        //   checkoutButton.classList?.add('hidden');
        // }
        return cartData;
      }

      async updateCart(id, quantity, ids = null) {
        let updates;
        if (ids) {
          updates = ids.reduce((a, v) => ({ ...a, [v]: 0 }), {});
        } else {
          updates = {
            [id]: quantity,
          };
        }

        let formData = JSON.stringify({ updates });
        if (this.cart) {
          const sections = ['drawer-cart'];
          const sections_url = window.location.pathname;
          formData = JSON.stringify({ updates, sections, sections_url });
        }

        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: formData,
        })
          .then((response) => {
            if (!response.ok) throw new Error(response.statusText);
            this.cartUpdateFailure = false;
            this.hideWarningMessage();
            return response.json();
          })
          .catch((error) => {
            this.cartUpdateFailure = true;
            this.showWarningMessage();
            this.removeIneligibleGifts();
            console.error('Error:', error);
          });
      }

      async addToCart(id, quantity, campaign_name) {
        const properties = {"_campaign": campaign_name, "_automatic_gift": true};
        const formData = { items: [{ id: id, quantity: quantity, properties }] };
        if (this.cart) {
          formData.sections = ['drawer-cart'];
          formData.sections_url = window.location.pathname;
        }
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            if (!response.ok) throw new Error(response.statusText);
            this.cartUpdateFailure = false;
            this.hideWarningMessage();
            return response.json();
          })
          .catch((error) => {
            this.cartUpdateFailure = true;
            this.showWarningMessage();
            this.removeIneligibleGifts();
            console.error('Error:', error);
          });
      }
    }
  );
}
